import { render, staticRenderFns } from "./DownloadAttributesDialog.vue?vue&type=template&id=7498d79e&scoped=true&"
import script from "./DownloadAttributesDialog.vue?vue&type=script&lang=js&"
export * from "./DownloadAttributesDialog.vue?vue&type=script&lang=js&"
import style0 from "./DownloadAttributesDialog.vue?vue&type=style&index=0&id=7498d79e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7498d79e",
  null
  
)

export default component.exports